export const isEmptyString = (val: unknown) => typeof val === 'string' && val === ''
